import Vue from 'vue'
import moment from 'moment'

import {
  ValidationObserver,
  ValidationProvider,
  extend,
  localize
} from 'vee-validate'

import { required, is, email, confirmed, alpha_spaces } from 'vee-validate/dist/rules'

extend('required', required)
extend('is', is)
extend('email', email)
extend('confirmed', confirmed)
extend('alpha_spaces', alpha_spaces)

extend('validDate', {
  validate (value, args) {
    // this is for nulls
    if (!value) return false
    const mVal = moment(value)
    if (!mVal.isValid()) return false
    // this is lower limit
    if (args.min && moment(args.min).isAfter(mVal)) return false
    // this is higher limit
    if (args.max && moment(args.max).isBefore(mVal)) return false
    return true
  },
  params: ['min', 'max']
})

Vue.component('ValidationObserver', ValidationObserver)
Vue.component('ValidationProvider', ValidationProvider)

export { localize }
